import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function FlowsIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <path
        d="M80 50v14M44 78V64h72v14M44 100v10h72v-10M80 110v6"
        stroke={c.p300}
        strokeWidth="3"
      />
      <rect x="60" y="26" width="40" height="24" rx="8" fill={c.p500} />
      <circle cx="80" cy="38" r="4" fill={c.n0} />
      <rect
        x="26"
        y="78"
        width="36"
        height="22"
        rx="8"
        fill={c.n0}
        stroke={c.p300}
        strokeWidth="2"
      />
      <rect
        x="98"
        y="78"
        width="36"
        height="22"
        rx="8"
        fill={c.n0}
        stroke={c.p300}
        strokeWidth="2"
      />
      <circle cx="44" cy="89" r="4" fill={c.p400} />
      <circle cx="116" cy="89" r="4" fill={c.p400} />
      <rect x="62" y="116" width="36" height="22" rx="8" fill={c.a400} />
      <circle cx="80" cy="127" r="4" fill={c.n0} />
    </Frame>
  );
}
